import {
  BANK_ACCOUNT_REQUEST,
  BANK_ACCOUNT_SUCCESS,
  BANK_ACCOUNT_LOADING,
  BANK_ACCOUNT_ERROR,
  POST_BANK_ACCOUNT,
  DOCUMENTS_REQUEST,
  DOCUMENT_ITEM_REQUEST,
  DOCUMENTS_ERROR,
  DOCUMENTS_LOADING,
  DOCUMENTS_SUCCESS,
  DOCUMENT_ITEM_SUCCESS,
  POST_FILING_DECISION,
  POST_FILING_DECISION_ERROR,
  POST_FILING_DECISION_LOADING,
  POST_FILING_DECISION_SUCCESS,
  CLOSE_APP,
  CLOSE_APP_ERROR,
  CLOSE_APP_LOADING,
  CLOSE_APP_SUCCESS,
  POST_PROOF_FILE,
  POST_PROOF_FILE_SUCCESS,
  DELETE_PROOF_FILE,
  DELETE_PROOF_FILE_SUCCESS,
  DOWNLOAD_PROOF_FILE,
  FETCH_PROOF_FILES,
  FETCH_PROOF_FILES_SUCCESS,
  PROOF_FILES_ERROR,
  PROOF_FILES_LOADING,
  UNLOCK_SECTIONS,
  PRINT_TWO_COPIES_REQUEST,
  PRINT_COPIES_SUCCESS,
} from '@/app/file/store/types';

import { http } from '@/api';
import { REFRESH_REQUEST } from '@/app/auth/store/types';
import { SECTIONS_REQUEST } from '@/app/main/store/types';

export const actions = {
  [BANK_ACCOUNT_REQUEST]: ({ commit, dispatch }, userId) => new Promise(((resolve, reject) => {
    commit(BANK_ACCOUNT_LOADING);
    http.get(`/file/apps/${userId}/bank-account`)
      .then((resp) => {
        commit(BANK_ACCOUNT_SUCCESS, resp.data);
        resolve(resp);
      })
      .catch((err) => {
        commit(BANK_ACCOUNT_ERROR);
        if (err.response.status === 401) {
          dispatch(REFRESH_REQUEST)
            .then(() => {
              dispatch(BANK_ACCOUNT_REQUEST, userId);
            });
        } else if (err.response.status !== 404) {
          reject(err);
        }
      });
  })),
  [POST_BANK_ACCOUNT]: ({ commit }, item) => new Promise(((resolve, reject) => {
    commit(BANK_ACCOUNT_LOADING);
    http.put(`/file/apps/${item.userId}/bank-account`, item.newItem)
      .then((resp) => {
        commit(BANK_ACCOUNT_SUCCESS, resp);
        resolve(resp);
      })
      .catch((err) => {
        commit(BANK_ACCOUNT_ERROR);
        reject(err);
      });
  })),
  [DOCUMENTS_REQUEST]: ({ commit, dispatch }, userId) => new Promise((resolve, reject) => {
    commit(DOCUMENTS_LOADING);
    http.get(`/file/apps/${userId}/pdf-files`)
      .then((resp) => {
        commit(DOCUMENTS_SUCCESS, resp.data);
        resolve(resp);
      })
      .catch((err) => {
        commit(DOCUMENTS_ERROR);
        if (err.response.status === 401) {
          dispatch(REFRESH_REQUEST)
            .then(() => {
              dispatch(DOCUMENTS_REQUEST, userId);
            });
        } else {
          reject(err);
        }
      });
  }),
  [PRINT_TWO_COPIES_REQUEST]: ({ commit, dispatch },
    requestData) => new Promise((resolve, reject) => {
    commit(DOCUMENTS_LOADING);
    http.get(`/file/apps/${requestData.userId}/print-2-copies`, {
      responseType: 'blob',
    })
      .then((resp) => {
        commit(PRINT_COPIES_SUCCESS, resp.data);
        resolve(resp);
      })
      .catch((err) => {
        commit(DOCUMENTS_ERROR);
        if (err.response.status === 401) {
          dispatch(REFRESH_REQUEST)
            .then(() => {
              dispatch(PRINT_TWO_COPIES_REQUEST, requestData.userId);
            });
        } else {
          reject(err);
        }
      });
  }),
  [DOCUMENT_ITEM_REQUEST]: ({ commit, dispatch }, requestData) => new Promise((resolve, reject) => {
    commit(DOCUMENTS_LOADING);
    http.get(`/file/apps/${requestData.userId}/pdf-files/${requestData.fileId}`, {
      responseType: 'blob',
    })
      .then((resp) => {
        commit(DOCUMENT_ITEM_SUCCESS);
        resolve(resp);
      })
      .catch((err) => {
        commit(DOCUMENTS_ERROR);
        if (err.response.status === 401) {
          dispatch(REFRESH_REQUEST)
            .then(() => {
              dispatch(DOCUMENT_ITEM_REQUEST, requestData);
            });
        } else {
          reject(err);
        }
      });
  }),
  [POST_FILING_DECISION]: ({ commit }, data) => new Promise((resolve, reject) => {
    commit(POST_FILING_DECISION_LOADING);
    http.post(`/qualify/apps/${data.userId}/filing?filingType=${data.filingType}`)
      .then((res) => {
        commit(POST_FILING_DECISION_SUCCESS);
        resolve(res);
      })
      .catch((err) => {
        commit(POST_FILING_DECISION_ERROR);
        reject(err);
      });
  }),
  [CLOSE_APP]: ({ commit }, userId) => new Promise((resolve, reject) => {
    commit(CLOSE_APP_LOADING);
    http.post(`/file/apps/${userId}/close`)
      .then((response) => {
        commit(CLOSE_APP_SUCCESS);
        resolve(response);
      })
      .catch((err) => {
        commit(CLOSE_APP_ERROR);
        reject(err);
      });
  }),
  [FETCH_PROOF_FILES]: ({ commit, dispatch }, data) => new Promise(((resolve, reject) => {
    commit(PROOF_FILES_LOADING);
    http.get(`/file/apps/${data.userId}/proof-file?types=${data.type}`)
      .then((resp) => {
        commit(FETCH_PROOF_FILES_SUCCESS, resp.data);
        resolve(resp);
      })
      .catch((err) => {
        commit(PROOF_FILES_ERROR);
        if (err.response.status === 401) {
          dispatch(REFRESH_REQUEST)
            .then(() => {
              dispatch(FETCH_PROOF_FILES, data.userId);
            });
        } else if (err.response.status !== 404) {
          reject(err);
        }
      });
  })),
  [POST_PROOF_FILE]: ({ commit }, item) => new Promise(((resolve, reject) => {
    commit(PROOF_FILES_LOADING);
    http.post(`/file/apps/${item.userId}/proof-file?type=${item.type}`, item.formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
      .then((resp) => {
        commit(POST_PROOF_FILE_SUCCESS, resp.data);
        resolve(resp);
      })
      .catch((err) => {
        commit(PROOF_FILES_ERROR);
        reject(err);
      });
  })),
  [DELETE_PROOF_FILE]: ({ commit }, item) => new Promise(((resolve, reject) => {
    commit(PROOF_FILES_LOADING);
    http.delete(`/file/apps/${item.userId}/proof-file/${item.id}`)
      .then((resp) => {
        commit(DELETE_PROOF_FILE_SUCCESS, item.id);
        resolve(resp);
      })
      .catch((err) => {
        commit(PROOF_FILES_ERROR);
        reject(err);
      });
  })),
  [DOWNLOAD_PROOF_FILE]: ({ dispatch }, file) => new Promise((resolve, reject) => {
    http.get(`/file/apps/${file.userId}/proof-file/${file.id}`, {
      responseType: 'blob',
    }).then((resp) => {
      resolve(resp);
    }).catch((err) => {
      if (err.response.status === 401) {
        dispatch(REFRESH_REQUEST)
          .then(() => {
            dispatch(DOWNLOAD_PROOF_FILE, file);
          });
      } else {
        reject(err);
      }
    });
  }),
  [UNLOCK_SECTIONS]: ({ dispatch }, userId) => new Promise((resolve, reject) => {
    http.post(`/file/apps/${userId}/unlock-file-section`)
      .then(() => {
        dispatch(SECTIONS_REQUEST, userId);
        resolve();
      })
      .catch(() => {
        reject();
      });
  }),
};
